import Vue from 'vue'
import Vuex from 'vuex'
import config from './config'
import user from './user'
import editor from './editor'
import pay from './pay'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    config,
    user,
    editor,
    pay
  }
})
